<template>
  <v-autocomplete
    required
    :multiple="multiple"
    :rules="rules"
    :items="list"
    v-model="select"
    @change="_fnChange"
    :readonly="readonly"
    :clearable="!readonly && !rules"
  >
    <template #label>
      {{ $t(`table.province`) }}
      <span class="red--text" v-if="rules">
        <strong>*</strong>
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  model: {
    prop: "selected",
    event: "change",
  },
  props: {
    selected: [String, Array],
    rules: Array,
    multiple: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      select: "",
      list: [],
    };
  },
  watch: {
    selected: function () {
      this.select = this.selected || "";
    },
  },
  created() {
    this.Province.filter.limit = 1000;
    this.Province.filter.sort = "name:1";
    this.fnGets({
      url: "/v1/admin/province",
      model: "Province",
    }).then(({ data }) => {
      this.Province.list = [];
      data.forEach((e) => {
        e.text = e.name;
        e.value = e.id;
      });
      this.list = data;
      this.select = this.selected || "";
    });
  },
  methods: {
    _fnChange() {
      this.$emit("change", this.select);
    },
  },
};
</script>
